import { useCallback } from 'react';
import { useSelector, useDispatch } from '.';
import { setSelectedTab, TabMenuIdentity } from '_common/redux/TabMenuSlice';

const useTabsState = (menuId: TabMenuIdentity) => {
  const tab = useSelector((state) => state.tabMenu[menuId]);

  const dispatch = useDispatch();

  const onTabChange = useCallback(
    (value: string) => {
      dispatch(setSelectedTab({ menuId, selectedTab: value }));
    },
    [menuId],
  );

  return {
    tab,
    onTabChange,
  };
};

export default useTabsState;
